// John Eldhose 20180705
import { RestfulPost } from './Restful';

export async function resendverify(email) {
  let data = {
    email: email
  };
  const resendverify = await RestfulPost('resendverify', data, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return resendverify;
}



// WEBPACK FOOTER //
// ./src/Api/resendverify.js